import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-d355a1fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-event-container" }
const _hoisted_2 = { class: "header-actions" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Add New Event", -1))
const _hoisted_4 = { class: "calendar-name" }
const _hoisted_5 = {
  key: 0,
  class: "error-message"
}
const _hoisted_6 = { class: "form-section" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Basic Information", -1))
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Event Title *", -1))
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "type" }, "Event Type *", -1))
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<option value=\"\" data-v-d355a1fa>Select Event Type</option><option value=\"closed\" data-v-d355a1fa>Closed</option><option value=\"early\" data-v-d355a1fa>Early</option><option value=\"shortened\" data-v-d355a1fa>Shortened</option><option value=\"late_start\" data-v-d355a1fa>Late Start</option>", 5)
const _hoisted_17 = [
  _hoisted_12
]
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Description", -1))
const _hoisted_20 = { class: "form-section" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Date and Time", -1))
const _hoisted_22 = { class: "form-row" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "startDate" }, "Start Date *", -1))
const _hoisted_25 = ["min", "max"]
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "endDate" }, "End Date", -1))
const _hoisted_28 = ["min", "max"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Leave blank for single-day events", -1))
const _hoisted_30 = { class: "form-group checkbox-group" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "isAllDay" }, "All Day Event", -1))
const _hoisted_32 = { class: "form-group checkbox-group" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "isAllWeek" }, "All Week Event", -1))
const _hoisted_34 = {
  key: 0,
  class: "form-row"
}
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "startTime" }, "Start Time", -1))
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "endTime" }, "End Time", -1))
const _hoisted_39 = { class: "form-group checkbox-group" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "affectsAttendance" }, "This event affects attendance", -1))
const _hoisted_41 = { class: "form-section" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Grade Ranges", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "help-text" }, "Select which grade levels this event applies to", -1))
const _hoisted_44 = { class: "grade-ranges" }
const _hoisted_45 = { class: "form-group checkbox-group" }
const _hoisted_46 = ["checked"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "allGrades" }, "All Grades", -1))
const _hoisted_48 = { class: "form-group checkbox-group" }
const _hoisted_49 = ["checked", "disabled"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "elementary" }, "Elementary (PreK-5)", -1))
const _hoisted_51 = { class: "form-group checkbox-group" }
const _hoisted_52 = ["checked", "disabled"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "middle" }, "Middle School (6-8)", -1))
const _hoisted_54 = { class: "form-group checkbox-group" }
const _hoisted_55 = ["checked", "disabled"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "high" }, "High School (9-12)", -1))
const _hoisted_57 = { class: "form-section" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Recurring Options", -1))
const _hoisted_59 = { class: "form-group checkbox-group" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "isRecurring" }, "This is a recurring event", -1))
const _hoisted_61 = {
  key: 0,
  class: "recurring-options"
}
const _hoisted_62 = { class: "form-group" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "recurrencePreset" }, "Recurrence Preset", -1))
const _hoisted_64 = /*#__PURE__*/_createStaticVNode("<option value=\"\" data-v-d355a1fa>Custom</option><option value=\"every_wed\" data-v-d355a1fa>Every Wednesday</option><option value=\"every_other_wed\" data-v-d355a1fa>Every Other Wednesday</option><option value=\"every_weekday\" data-v-d355a1fa>Every Weekday (Mon–Fri)</option><option value=\"mwf\" data-v-d355a1fa>Every Mon, Wed, Fri</option>", 5)
const _hoisted_69 = [
  _hoisted_64
]
const _hoisted_70 = { class: "form-row" }
const _hoisted_71 = {
  class: "form-group",
  style: {"max-width":"120px"}
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "recurrenceInterval" }, "Repeat Every", -1))
const _hoisted_73 = {
  class: "form-group",
  style: {"max-width":"160px"}
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "recurrenceUnit" }, " ", -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "day" }, "Day(s)", -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "week" }, "Week(s)", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "month" }, "Month(s)", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "year" }, "Year(s)", -1))
const _hoisted_79 = [
  _hoisted_75,
  _hoisted_76,
  _hoisted_77,
  _hoisted_78
]
const _hoisted_80 = {
  key: 0,
  class: "form-group"
}
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "On", -1))
const _hoisted_82 = { class: "weekday-picker" }
const _hoisted_83 = ["onClick"]
const _hoisted_84 = {
  key: 1,
  class: "form-group"
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Repeat On", -1))
const _hoisted_86 = { style: {"display":"flex","gap":"12px","align-items":"center"} }
const _hoisted_87 = { class: "form-group" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Ends", -1))
const _hoisted_89 = { style: {"display":"flex","gap":"16px","align-items":"center","flex-wrap":"wrap"} }
const _hoisted_90 = ["disabled"]
const _hoisted_91 = ["min", "disabled"]
const _hoisted_92 = { class: "form-group" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Exclusion Dates", -1))
const _hoisted_94 = { style: {"display":"flex","gap":"8px","align-items":"center","margin-bottom":"6px"} }
const _hoisted_95 = ["min"]
const _hoisted_96 = { key: 0 }
const _hoisted_97 = ["onClick"]
const _hoisted_98 = {
  key: 1,
  class: "form-group",
  style: {"margin-top":"18px"}
}
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Preview Dates", -1))
const _hoisted_100 = { key: 0 }
const _hoisted_101 = { style: {"max-height":"120px","overflow-y":"auto","background":"#f9fafb","border-radius":"6px","padding":"8px 12px","border":"1px solid #e5e7eb","font-size":"0.98rem"} }
const _hoisted_102 = {
  key: 0,
  style: {"color":"#888","font-size":"0.95rem","margin-top":"4px"}
}
const _hoisted_103 = {
  key: 1,
  style: {"color":"#b91c1c","font-size":"0.98rem"}
}
const _hoisted_104 = { class: "form-actions" }
const _hoisted_105 = ["disabled"]
const _hoisted_106 = { key: 0 }
const _hoisted_107 = { key: 1 }

import { ref, reactive, onMounted, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import axios from "axios";
import { API_URL } from "../config";
import { getErrorMessage } from "../types";
import type { EventFormData, GeneratedCalendarEvent } from "../types";

// Router and Route

export default /*#__PURE__*/_defineComponent({
  __name: 'AddEventView',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const calendarId = route.params.calendarId as string;

// State
const calendarName = ref("");
const calendarStartDate = ref("");
const calendarEndDate = ref("");
const error = ref("");
const isSubmitting = ref(false);

const weekdays = [
  { label: "Mon", value: 1 },
  { label: "Tue", value: 2 },
  { label: "Wed", value: 3 },
  { label: "Thu", value: 4 },
  { label: "Fri", value: 5 },
  { label: "Sat", value: 6 },
  { label: "Sun", value: 0 },
];

// Form data
const formData = reactive<EventFormData>({
  title: "",
  type: "",
  description: "",
  startDate: "",
  endDate: "",
  startTime: "",
  endTime: "",
  isAllDay: false,
  isAllWeek: false,
  isRecurring: false,
  recurrenceInterval: 1,
  recurrenceUnit: "week",
  recurrenceDays: [3], // Default to Wednesday
  monthlyRepeatType: "day", // 'day' or 'weekday'
  recurrenceEndType: "never", // 'never', 'after', 'on'
  recurrenceEndAfter: 10,
  recurrenceEndDate: "",
  recurrenceExclusions: [] as string[],
  affectsAttendance: true,
  gradeRanges: ["all_grades"] as string[],
});

const exclusionDateInput = ref("");
const recurrencePreset = ref("");

const previewDates = computed(() => {
  // Use the same logic as generateEvents, but just return the date strings (limit to 20 for preview)
  const eventData = { ...formData };
  const events = generateEvents(eventData);
  return events.slice(0, 20).map((e) => e.startDate);
});

// Functions
const fetchCalendar = async () => {
  try {
    const response = await axios.get(`${API_URL}/calendar/${calendarId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    const calendar = response.data;
    calendarName.value = calendar.name;
    calendarStartDate.value = calendar.startDate;
    calendarEndDate.value = calendar.endDate;

    // Set default start date to today if within calendar range
    const today = new Date().toISOString().split("T")[0];
    if (today >= calendar.startDate && today <= calendar.endDate) {
      formData.startDate = today;
    } else {
      formData.startDate = calendar.startDate;
    }

    // Set default times if available
    if (calendar.defaultStartTime) {
      formData.startTime = calendar.defaultStartTime;
    }
    if (calendar.defaultEndTime) {
      formData.endTime = calendar.defaultEndTime;
    }
  } catch (err: unknown) {
    error.value = getErrorMessage(err, "Failed to fetch calendar");
    console.error("Error fetching calendar:", err);
  }
};

// Handle all day change
const handleAllDayChange = (event: Event) => {
  const isChecked = (event.target as HTMLInputElement).checked;
  if (isChecked) {
    formData.startTime = "";
    formData.endTime = "";
    formData.isAllWeek = false;
  }
};

// Handle all week change
const handleAllWeekChange = (event: Event) => {
  const isChecked = (event.target as HTMLInputElement).checked;
  if (isChecked) {
    formData.startTime = "";
    formData.endTime = "";
    formData.isAllDay = false;
    // Set end date to end of week
    const startDate = new Date(formData.startDate);
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + (6 - startDate.getDay()));
    formData.endDate = endDate.toISOString().split("T")[0];
  } else {
    formData.endDate = "";
  }
};

// Generate events for multi-day and recurring events
const generateEvents = (eventData: EventFormData): GeneratedCalendarEvent[] => {
  // If not recurring, fallback to single/multi-day logic
  if (!eventData.isRecurring) {
    if (!eventData.endDate || eventData.endDate === eventData.startDate) {
      return [eventData];
    }
    const events: GeneratedCalendarEvent[] = [];
    const startDate = new Date(eventData.startDate);
    const endDate = new Date(eventData.endDate);
    const currentDate = new Date(startDate);
    while (currentDate <= endDate) {
      const event = {
        ...eventData,
        startDate: currentDate.toISOString().split("T")[0],
        endDate: currentDate.toISOString().split("T")[0],
      };
      events.push(event);
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return events;
  }

  // Recurring logic
  const {
    startDate,
    recurrenceInterval,
    recurrenceUnit,
    recurrenceDays,
    recurrenceEndDate,
  } = eventData;
  const events: GeneratedCalendarEvent[] = [];
  let current = new Date(startDate);
  const end = new Date(recurrenceEndDate || startDate);

  // Helper for day of week (0=Sun, 1=Mon, ... 6=Sat)
  const getDay = (date: Date) => date.getDay();

  if (recurrenceUnit === "day") {
    while (current <= end) {
      events.push({
        ...eventData,
        startDate: current.toISOString().split("T")[0],
        endDate: current.toISOString().split("T")[0],
      });
      current.setDate(current.getDate() + recurrenceInterval);
    }
  } else if (recurrenceUnit === "week") {
    // Find the first week that matches
    let weekStart = new Date(current);
    while (weekStart <= end) {
      // For each selected day in the week
      for (const day of recurrenceDays) {
        // Calculate the date for this day in the current week
        const eventDate = new Date(weekStart);
        // Adjust to the correct day of week
        eventDate.setDate(weekStart.getDate() - getDay(weekStart) + day);
        // Only add if in range
        if (eventDate >= new Date(startDate) && eventDate <= end) {
          events.push({
            ...eventData,
            startDate: eventDate.toISOString().split("T")[0],
            endDate: eventDate.toISOString().split("T")[0],
          });
        }
      }
      // Move to next interval week
      weekStart.setDate(weekStart.getDate() + 7 * recurrenceInterval);
    }
  } else if (recurrenceUnit === "month") {
    while (current <= end) {
      events.push({
        ...eventData,
        startDate: current.toISOString().split("T")[0],
        endDate: current.toISOString().split("T")[0],
      });
      current.setMonth(current.getMonth() + recurrenceInterval);
    }
  } else if (recurrenceUnit === "year") {
    while (current <= end) {
      events.push({
        ...eventData,
        startDate: current.toISOString().split("T")[0],
        endDate: current.toISOString().split("T")[0],
      });
      current.setFullYear(current.getFullYear() + recurrenceInterval);
    }
  }
  return events;
};

const submitForm = async () => {
  // Validate form
  if (!formData.title) {
    error.value = "Please enter an event title";
    return;
  }

  if (!formData.type) {
    error.value = "Please select an event type";
    return;
  }

  if (!formData.startDate) {
    error.value = "Please select a start date";
    return;
  }

  isSubmitting.value = true;
  error.value = "";

  try {
    // Prepare data for submission
    const eventData = {
      ...formData,
    };

    // Generate events for multi-day and recurring events
    const events = generateEvents(eventData);

    // Create all events
    for (const event of events) {
      await axios.post(`${API_URL}/calendar/${calendarId}/events`, event, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
    }

    // Navigate back to events list
    router.push(`/calendar/${calendarId}/events`);
  } catch (err: unknown) {
    isSubmitting.value = false;
    error.value = getErrorMessage(err, "Failed to create event");
    console.error("Error creating event:", err);
  }
};

const goBack = () => {
  router.push(`/calendar/${calendarId}/events`);
};

function toggleRecurrenceDay(day: number) {
  const idx = formData.recurrenceDays.indexOf(day);
  if (idx === -1) formData.recurrenceDays.push(day);
  else formData.recurrenceDays.splice(idx, 1);
}

function addExclusionDate() {
  if (
    exclusionDateInput.value &&
    !formData.recurrenceExclusions.includes(exclusionDateInput.value)
  ) {
    formData.recurrenceExclusions.push(exclusionDateInput.value);
    exclusionDateInput.value = "";
  }
}
function removeExclusionDate(idx: number) {
  formData.recurrenceExclusions.splice(idx, 1);
}

function getDayOfMonth(dateStr: string) {
  if (!dateStr) return "";
  return new Date(dateStr).getDate();
}
function getMonthlyWeekdayText(dateStr: string) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const weekday = weekdays[date.getDay()].label;
  const nth = Math.ceil(date.getDate() / 7);
  const nthText = ["1st", "2nd", "3rd", "4th", "5th"][nth - 1] || `${nth}th`;
  return `the ${nthText} ${weekday}`;
}

function applyRecurrencePreset() {
  if (recurrencePreset.value === "every_wed") {
    formData.recurrenceInterval = 1;
    formData.recurrenceUnit = "week";
    formData.recurrenceDays = [3];
  } else if (recurrencePreset.value === "every_other_wed") {
    formData.recurrenceInterval = 2;
    formData.recurrenceUnit = "week";
    formData.recurrenceDays = [3];
  } else if (recurrencePreset.value === "every_weekday") {
    formData.recurrenceInterval = 1;
    formData.recurrenceUnit = "week";
    formData.recurrenceDays = [1, 2, 3, 4, 5];
  } else if (recurrencePreset.value === "mwf") {
    formData.recurrenceInterval = 1;
    formData.recurrenceUnit = "week";
    formData.recurrenceDays = [1, 3, 5];
  }
  // If custom, do nothing (user can use advanced options)
}

// Update the handlers in the script section
const handleAllGradesChange = (event: Event) => {
  const isChecked = (event.target as HTMLInputElement).checked;
  console.log("All grades checkbox changed:", isChecked);

  if (isChecked) {
    formData.gradeRanges = ["all_grades"];
  } else {
    // When unchecking "All Grades", default to elementary
    formData.gradeRanges = ["elementary"];
  }

  console.log("Updated grade ranges:", formData.gradeRanges);
};

const handleGradeRangeChange = (grade: string, event: Event) => {
  const isChecked = (event.target as HTMLInputElement).checked;
  console.log(`${grade} checkbox changed:`, isChecked);

  if (isChecked) {
    // Add the grade if it's not already in the array
    if (!formData.gradeRanges.includes(grade)) {
      formData.gradeRanges.push(grade);
    }
  } else {
    // Remove the grade from the array
    formData.gradeRanges = formData.gradeRanges.filter((g) => g !== grade);

    // If no grades are selected, default to all grades
    if (formData.gradeRanges.length === 0) {
      formData.gradeRanges = ["all_grades"];
    }
  }

  console.log("Updated grade ranges:", formData.gradeRanges);
};

// Lifecycle hooks
onMounted(() => {
  fetchCalendar();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn-back",
        onClick: goBack
      }, [
        _createVNode(_unref(FontAwesomeIcon), { icon: "arrow-left" }),
        _createTextVNode(" Back to Events ")
      ])
    ]),
    _hoisted_3,
    _createElementVNode("p", _hoisted_4, "Calendar: " + _toDisplayString(calendarName.value), 1),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      onSubmit: _withModifiers(submitForm, ["prevent"]),
      class: "event-form"
    }, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "title",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.title) = $event)),
            required: "",
            placeholder: "Enter event title"
          }, null, 512), [
            [_vModelText, formData.title]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("select", {
            id: "type",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.type) = $event)),
            required: ""
          }, _hoisted_17, 512), [
            [_vModelSelect, formData.type]
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _withDirectives(_createElementVNode("textarea", {
            id: "description",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.description) = $event)),
            placeholder: "Enter event description",
            rows: "3"
          }, null, 512), [
            [_vModelText, formData.description]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _withDirectives(_createElementVNode("input", {
              type: "date",
              id: "startDate",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.startDate) = $event)),
              required: "",
              min: calendarStartDate.value,
              max: calendarEndDate.value
            }, null, 8, _hoisted_25), [
              [_vModelText, formData.startDate]
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _withDirectives(_createElementVNode("input", {
              type: "date",
              id: "endDate",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.endDate) = $event)),
              min: formData.startDate,
              max: calendarEndDate.value
            }, null, 8, _hoisted_28), [
              [_vModelText, formData.endDate]
            ]),
            _hoisted_29
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            id: "isAllDay",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.isAllDay) = $event)),
            onChange: handleAllDayChange
          }, null, 544), [
            [_vModelCheckbox, formData.isAllDay]
          ]),
          _hoisted_31
        ]),
        _createElementVNode("div", _hoisted_32, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            id: "isAllWeek",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.isAllWeek) = $event)),
            onChange: handleAllWeekChange
          }, null, 544), [
            [_vModelCheckbox, formData.isAllWeek]
          ]),
          _hoisted_33
        ]),
        (!formData.isAllDay && !formData.isAllWeek)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _withDirectives(_createElementVNode("input", {
                  type: "time",
                  id: "startTime",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.startTime) = $event))
                }, null, 512), [
                  [_vModelText, formData.startTime]
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _withDirectives(_createElementVNode("input", {
                  type: "time",
                  id: "endTime",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.endTime) = $event))
                }, null, 512), [
                  [_vModelText, formData.endTime]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_39, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            id: "affectsAttendance",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.affectsAttendance) = $event))
          }, null, 512), [
            [_vModelCheckbox, formData.affectsAttendance]
          ]),
          _hoisted_40
        ])
      ]),
      _createElementVNode("div", _hoisted_41, [
        _hoisted_42,
        _hoisted_43,
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("input", {
              type: "checkbox",
              id: "allGrades",
              checked: formData.gradeRanges.includes('all_grades'),
              onChange: handleAllGradesChange
            }, null, 40, _hoisted_46),
            _hoisted_47
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("input", {
              type: "checkbox",
              id: "elementary",
              checked: formData.gradeRanges.includes('elementary'),
              onChange: _cache[10] || (_cache[10] = ($event: any) => (handleGradeRangeChange('elementary', $event))),
              disabled: formData.gradeRanges.includes('all_grades')
            }, null, 40, _hoisted_49),
            _hoisted_50
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("input", {
              type: "checkbox",
              id: "middle",
              checked: formData.gradeRanges.includes('middle'),
              onChange: _cache[11] || (_cache[11] = ($event: any) => (handleGradeRangeChange('middle', $event))),
              disabled: formData.gradeRanges.includes('all_grades')
            }, null, 40, _hoisted_52),
            _hoisted_53
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("input", {
              type: "checkbox",
              id: "high",
              checked: formData.gradeRanges.includes('high'),
              onChange: _cache[12] || (_cache[12] = ($event: any) => (handleGradeRangeChange('high', $event))),
              disabled: formData.gradeRanges.includes('all_grades')
            }, null, 40, _hoisted_55),
            _hoisted_56
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_57, [
        _hoisted_58,
        _createElementVNode("div", _hoisted_59, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            id: "isRecurring",
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.isRecurring) = $event))
          }, null, 512), [
            [_vModelCheckbox, formData.isRecurring]
          ]),
          _hoisted_60
        ]),
        (formData.isRecurring)
          ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _hoisted_63,
                _withDirectives(_createElementVNode("select", {
                  id: "recurrencePreset",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((recurrencePreset).value = $event)),
                  onChange: applyRecurrencePreset
                }, _hoisted_69, 544), [
                  [_vModelSelect, recurrencePreset.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _hoisted_72,
                  _withDirectives(_createElementVNode("input", {
                    id: "recurrenceInterval",
                    type: "number",
                    min: "1",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.recurrenceInterval) = $event))
                  }, null, 512), [
                    [
                      _vModelText,
                      formData.recurrenceInterval,
                      void 0,
                      { number: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _hoisted_74,
                  _withDirectives(_createElementVNode("select", {
                    id: "recurrenceUnit",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.recurrenceUnit) = $event))
                  }, _hoisted_79, 512), [
                    [_vModelSelect, formData.recurrenceUnit]
                  ])
                ])
              ]),
              (formData.recurrenceUnit === 'week')
                ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                    _hoisted_81,
                    _createElementVNode("div", _hoisted_82, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekdays, (day) => {
                        return _createElementVNode("button", {
                          key: day.value,
                          type: "button",
                          class: _normalizeClass([
                  'weekday-btn',
                  { selected: formData.recurrenceDays.includes(day.value) },
                ]),
                          onClick: ($event: any) => (toggleRecurrenceDay(day.value))
                        }, _toDisplayString(day.label), 11, _hoisted_83)
                      }), 64))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (formData.recurrenceUnit === 'month')
                ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                    _hoisted_85,
                    _createElementVNode("div", _hoisted_86, [
                      _createElementVNode("label", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          value: "day",
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.monthlyRepeatType) = $event))
                        }, null, 512), [
                          [_vModelRadio, formData.monthlyRepeatType]
                        ]),
                        _createTextVNode(" Day " + _toDisplayString(getDayOfMonth(formData.startDate)), 1)
                      ]),
                      _createElementVNode("label", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          value: "weekday",
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.monthlyRepeatType) = $event))
                        }, null, 512), [
                          [_vModelRadio, formData.monthlyRepeatType]
                        ]),
                        _createTextVNode(" " + _toDisplayString(getMonthlyWeekdayText(formData.startDate)), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_87, [
                _hoisted_88,
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      value: "never",
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formData.recurrenceEndType) = $event))
                    }, null, 512), [
                      [_vModelRadio, formData.recurrenceEndType]
                    ]),
                    _createTextVNode(" Never ")
                  ]),
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      value: "after",
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formData.recurrenceEndType) = $event))
                    }, null, 512), [
                      [_vModelRadio, formData.recurrenceEndType]
                    ]),
                    _createTextVNode(" After "),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      min: "1",
                      style: {"width":"60px","margin":"0 4px"},
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formData.recurrenceEndAfter) = $event)),
                      disabled: formData.recurrenceEndType !== 'after'
                    }, null, 8, _hoisted_90), [
                      [
                        _vModelText,
                        formData.recurrenceEndAfter,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _createTextVNode(" occurrences ")
                  ]),
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      value: "on",
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((formData.recurrenceEndType) = $event))
                    }, null, 512), [
                      [_vModelRadio, formData.recurrenceEndType]
                    ]),
                    _createTextVNode(" On "),
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((formData.recurrenceEndDate) = $event)),
                      min: formData.startDate,
                      disabled: formData.recurrenceEndType !== 'on'
                    }, null, 8, _hoisted_91), [
                      [_vModelText, formData.recurrenceEndDate]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_92, [
                _hoisted_93,
                _createElementVNode("div", _hoisted_94, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((exclusionDateInput).value = $event)),
                    min: formData.startDate
                  }, null, 8, _hoisted_95), [
                    [_vModelText, exclusionDateInput.value]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-cancel",
                    style: {"padding":"4px 10px","font-size":"0.95rem"},
                    onClick: addExclusionDate
                  }, " Add ")
                ]),
                (formData.recurrenceExclusions.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.recurrenceExclusions, (date, i) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: date,
                          style: {"display":"inline-block","background":"#f3f4f6","color":"#374151","border-radius":"4px","padding":"2px 8px","margin-right":"6px","margin-bottom":"4px","font-size":"0.97rem"}
                        }, [
                          _createTextVNode(_toDisplayString(date) + " ", 1),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: ($event: any) => (removeExclusionDate(i)),
                            style: {"background":"none","border":"none","color":"#b91c1c","font-weight":"bold","margin-left":"4px","cursor":"pointer"}
                          }, " × ", 8, _hoisted_97)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (formData.isRecurring)
          ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
              _hoisted_99,
              (previewDates.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                    _createElementVNode("ul", _hoisted_101, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(previewDates.value, (date) => {
                        return (_openBlock(), _createElementBlock("li", { key: date }, _toDisplayString(date), 1))
                      }), 128))
                    ]),
                    (previewDates.value.length > 20)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_102, " ...and " + _toDisplayString(previewDates.value.length - 20) + " more ", 1))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_103, " No dates generated. Please check your recurrence settings. "))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_104, [
        _createElementVNode("button", {
          type: "button",
          class: "btn-cancel",
          onClick: goBack
        }, "Cancel"),
        _createElementVNode("button", {
          type: "submit",
          class: "btn-submit",
          disabled: isSubmitting.value
        }, [
          (isSubmitting.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_106, "Saving..."))
            : (_openBlock(), _createElementBlock("span", _hoisted_107, "Save Event"))
        ], 8, _hoisted_105)
      ])
    ], 32)
  ]))
}
}

})